module.exports = __webpack_public_path__ + "img/4.aead3196.png";